import {
  createColumnVisibilityStore,
  type ColumnDefinition,
} from "./createColumnVisibilityStore";

/**
 * The OS image table's columns, in render order.
 *
 * Labels match the table headers exactly — the menu is a list of what is on screen.
 *
 * Locked: the selection checkbox the bulk actions depend on, the image name that says which row
 * this is, and the actions menu.
 */
export const OS_IMAGE_COLUMNS = [
  { id: "select", label: "Selection", locked: true },
  { id: "image", label: "OS Image", locked: true },
  { id: "category", label: "Category" },
  { id: "license", label: "License" },
  { id: "template", label: "VM Template" },
  { id: "specs", label: "Min. Specs" },
  { id: "status", label: "Status" },
  { id: "usage", label: "Usage" },
  { id: "actions", label: "Actions", locked: true },
] as const satisfies readonly ColumnDefinition[];

export type OSImageColumnId = (typeof OS_IMAGE_COLUMNS)[number]["id"];

export const useOSImageColumnsStore = createColumnVisibilityStore<OSImageColumnId>({
  name: "admin.osImages.columns",
  columns: OS_IMAGE_COLUMNS,
});
